import { create } from 'zustand'
import { getThemeObject, TailwindTheme, Theme } from 'src/style/themes'

function validateTailwindTheme(value: string | null): value is TailwindTheme {
  return Object.values(TailwindTheme).includes(value as TailwindTheme)
}

function getThemeFromLocalStorage(): TailwindTheme {
  const theme = localStorage.getItem('tailwindTheme')
  return validateTailwindTheme(theme) ? theme : TailwindTheme.Legacy
}

type ThemeState = {
  theme: TailwindTheme
  setTheme: (theme: TailwindTheme) => void
  getTheme: () => Theme
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: getThemeFromLocalStorage(),
  setTheme: theme => {
    localStorage.setItem('tailwindTheme', theme)
    document.body.classList.remove(...Object.values(TailwindTheme))
    document.body.classList.add(theme)
    set({ theme })
  },
  getTheme: () => getThemeObject(get().theme),
}))

const initialTheme = useThemeStore.getState().theme
document.body.classList.remove(...Object.values(TailwindTheme))
document.body.classList.add(initialTheme)
